import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.sass'],
  imports: [MatButton, MatIcon, RouterLink, AsyncPipe, TranslocoDirective],
})
export class AccessDeniedComponent {
  private route = inject(ActivatedRoute);
  private transloco = inject(TranslocoService);

  message$ = combineLatest([this.route.queryParams, this.transloco.langChanges$]).pipe(
    map(([params]) => {
      switch (params['reason']) {
        case 'role':
          return this.transloco.translate('core.accessDenied.reasons.role');
        case 'module':
          return this.transloco.translate('core.accessDenied.reasons.module');
        default:
          return this.transloco.translate('core.accessDenied.reasons.default');
      }
    })
  );
}
